module.exports = __webpack_public_path__ + "img/112.14441d19.jpg";